<template>
  <c-modal :id="id">
    <div class="modal-container">
      <div class="modal-header">
        <div
          v-if="logoTop"
          class="logo-container"
        >
          <img
            src="../../../img/demis-digital.png"
            alt="Demis digital"
          >
        </div>
        <h4
          style="font-weight: bold;"
          :style="{textAlign: titleTextAlign}"
          class="modal-title"
        >
          {{ title }}
        </h4>
      </div>
      <div
        class="modal-body"
        :class="{ 'overlay-wrapper': loading }"
      >
        <c-alert
          v-if="error"
          type="danger"
        >
          Произошла ошибка. Попробуйте еще раз.
        </c-alert>
        <slot />
        <div
          v-if="submitBtn"
          class="text-center"
        >
          <!--
            Вызывается при нажатии на кнопку отправки.

            @event submit
            @property {Object} event Событие.
          -->
          <button
            :disabled="!submitBtnEnabled"
            class="btn background-white border-danger text-danger form-submit-btn"
            @click.prevent="$emit('submit', $event)"
            v-text="submitBtnText"
          />
        </div>
        <div
          v-if="fieldsRequired"
          class="text-center text-danger margin-top"
        >
          Поля отмеченные * обязательны к заполнению
        </div>
        <c-loading-overlay v-if="loading" />
      </div>
    </div>
  </c-modal>
</template>

<script>
import CModal from '../../components/ui/CModal'
import CLoadingOverlay from './CLoadingOverlay'
import CAlert from './CAlert'

/**
 * Модальное окно с формой.
 */
export default {
  name: 'CModalForm',
  components: {
    CModal,
    CLoadingOverlay,
    CAlert
  },
  props: {
    /**
     * Идентификатор.
     */
    id: {
      type: String,
      required: true
    },
    /**
     * Отображать ли логотип сверху.
     */
    logoTop: {
      type: Boolean,
      default: true
    },
    /**
     * Текст заголовка.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Выравнивание текста заголовка.
     *
     * @values center, left, right
     */
    titleTextAlign: {
      type: String,
      default: 'center'
    },
    /**
     * Статус загрузки.
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Отображать ли кнопку отправки.
     */
    submitBtn: {
      type: Boolean,
      default: true
    },
    /**
     * Разрешено ли нажатие кнопки отправки.
     */
    submitBtnEnabled: {
      type: Boolean,
      default: true
    },
    /**
     * Текст для кнопки отправки.
     */
    submitBtnText: {
      type: String,
      default: 'Отправить'
    },
    /**
     * Отображать ли сообщение об ошибке отправки.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Отображать ли текст о том, что поля обязательны к заполнению.
     */
    fieldsRequired: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.logo-container {
  text-align: center;
  padding-top: 0;
  padding-bottom: 15px;
  margin-bottom: 30px;
  border-bottom: 3px solid #d2d6de;
}

.modal-header {
  border-bottom: none;

  @media (max-width: $xsBreakpoint) {
    padding: 5px;
  }
}

.modal-body {
  @media (max-width: $xsBreakpoint) {
    padding: 5px;
  }
}

.modal-container {
  padding: 30px;

  @media (max-width: $xsBreakpoint) {
    padding: 0px;
  }
}

.form-submit-btn {
  width: 100%;
}
</style>
